<template>
  <v-container>
    <v-card elevation="8">
      <v-form v-model="isFormValid">
        <!--card title-->
        <v-card-title>
          <v-container>
            <span class="list-labels">Endereço</span>
          </v-container>
        </v-card-title>

        <!--card content-->
        <v-card-text>
          <v-container class="grid-list-sm">
            <v-row>
              <v-col cols="12" md="7">
                <v-container fluid pa-0>
                  <v-row>
                    <v-col cols="12">
                      <GoogleAutocomplete
                        id="address"
                        required
                        @placechanged="placechanged"
                        :rules="[validateGoogleAddress]"
                        v-model="address.googleAddress"
                        :disabled="saving"
                      />
                    </v-col>
                    <v-col cols="12" md="7">
                      <v-text-field
                        label="CEP"
                        v-mask="'#####-###'"
                        outlined
                        hide-details="auto"
                        required
                        v-model="address.postalCode"
                        :rules="[validatePostalCode]"
                        :disabled="saving"
                        @change="updateVModel"
                        @blur="findAddressByCep"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-text-field
                        label="Bairro"
                        outlined
                        hide-details="auto"
                        required
                        v-model="address.neighborhood"
                        :rules="[validateNeighborhood]"
                        :disabled="saving"
                        @change="updateVModel"
                        maxlength="50"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="7">
                      <v-text-field
                        label="Logradouro"
                        outlined
                        hide-details="auto"
                        required
                        v-model="address.street"
                        :rules="[validateStreet]"
                        :disabled="saving"
                        @change="updateVModel"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-text-field
                        label="Número"
                        outlined
                        hide-details="auto"
                        required
                        v-model="address.number"
                        :rules="[validateNumber]"
                        :disabled="saving"
                        @change="updateVModel"
                        maxlength="10"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Complemento"
                        outlined
                        hide-details="auto"
                        v-model="address.complement"
                        @change="updateVModel"
                        maxlength="10"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Cidade"
                        outlined
                        hide-details="auto"
                        required
                        v-model="address.city"
                        :rules="[validateCity]"
                        :disabled="false"
                        @change="updateVModel"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-combobox
                        :items="stateList"
                        item-text="shortName"
                        label="Estado"
                        outlined
                        hide-details="auto"
                        required
                        v-model="address.state"
                        :disabled="false"
                        :rules="[validateState]"
                        @change="updateVModel"
                      ></v-combobox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
              <v-col cols="12" md="5">
                <!-- API google - static MAP - imagem) -->
                <v-img
                  class="br-4"
                  :src="mapsUrl"
                  lazy-src="https://system4delaware.com/wp-content/uploads/2018/02/delaware-blur-map.jpg"
                  height="100%"
                  aspect-ratio="2"
                  cover
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="var(--gray-light)"
                        background="var(--bg)"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
// import CommonHelper from "@/scripts/helpers/common.helper";
import GeneralService from "@/scripts/services/general.service";
import cep from 'cep-promise';
export default {
  props: ["value"],
  data: () => ({
    address: {
      googleAddress: "",
      postalCode: "",
      street: "",
      number: "",
      neighborhood: "",
      city: "",
      state: "",
      country: "",
      complement: ""
    },
    stateList: [],
    isFormValid: false,
    generalService: new GeneralService(),
    saving: false
  }),
  created() {
    this.address = this.value;
    this.generalService
      .listAllStates()
      .then(result => (this.stateList = result));
  },
  mounted() {
    this.address = this.value;
  },
  computed: {
    mapsUrl() {
      if (this.address.googleAddress)
        return `https://maps.googleapis.com/maps/api/staticmap?center=${this.address.googleAddress}&&zoom=16&size=400x400&key=AIzaSyCtHC295UPpQz7IafjhBEKFD3l9fnti71s`;
      return "";
    },
    isValid() {
      return this.isFormValid;
    }
  },
  watch: {
    value() {
      this.address = this.value;
    }
  },
  methods: {
    findAddressByCep() {
      cep(this.address.postalCode).then((response) => {
        this.address.street = response.street;
        this.address.neighborhood = response.neighborhood;
        this.address.city = response.city;
        this.address.state = response.state;
        this.address.googleAddress = response.street;
      });
    },
    updateVModel() {
      this.$emit("input", this.address);
    },
    placechanged(formattedPlace) {
      this.address.postalCode = formattedPlace.postalCode || "";
      this.address.street = formattedPlace.street || "";
      this.address.number = formattedPlace.number || "";
      this.address.neighborhood = formattedPlace.neighborhood || "";
      this.address.city = formattedPlace.city || "";
      this.address.state = formattedPlace.state || "";
    },
    validateGoogleAddress() {
      if (!this.address.googleAddress) return "Preencha o endereço";
      return true;
    },
    validatePostalCode() {
      if (!this.address.postalCode) return "Preencha o CEP";
      return true;
    },
    validateStreet() {
      if (!this.address.street) return "Preencha o logradouro";
      return true;
    },
    validateNumber() {
      if (!this.address.number) return "Preencha o número";
      return true;
    },
    validateNeighborhood() {
      if (!this.address.neighborhood) return "Preencha o bairro";
      return true;
    },
    validateCity() {
      if (!this.address.city) return "Preencha a cidade";
      return true;
    },
    validateState() {
      if (!this.address.state) return "Preencha o estado";
      return true;
    }
  }
};
</script>
